import React from "react";
import { Card } from "antd";

const RatingScale = ({ items }) => (
  <Card className="mx-4 flex flex-col gap-6 rounded-xl border-2 border-purple-200 dark:bg-white/5">
    <h4 className="mb-5 text-[16px] dark:text-white">Rating Scale</h4>
    <div className="space-y-3">
      {items.map(({ label, description, color }) => (
        <div key={label} className="flex items-start gap-3 p-1 rounded-lg border">
          <div className={`w-2 h-2 flex-shrink-0 rounded-full ml-1.5 mt-1.5 ${color}`} />
          <div>
            <p className="font-semibold text-[14px] dark:text-white">{label}</p>
            <p className="text-[12px] dark:text-slate-100">{description}</p>
          </div>
        </div>
      ))}
    </div>
  </Card>
);
export default RatingScale;